import listActions from 'src/modules/appUser/list/appUserListActions';
import AppUserService from 'src/modules/appUser/appUserService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/store';
import Message from 'src/view/shared/message';

const prefix = 'APPUSER_DESTROY';

const appUserDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: appUserDestroyActions.DESTROY_STARTED,
      });

      await AppUserService.destroyAll([id]);

      dispatch({
        type: appUserDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.appUser.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      getHistory().push('/app-user');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      dispatch({
        type: appUserDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: appUserDestroyActions.DESTROY_ALL_STARTED,
      });

      await AppUserService.destroyAll(ids);

      dispatch({
        type: appUserDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doChangeSelected([]));
        dispatch(listActions.doFetchCurrentFilter());
        dispatch(listActions.doFetchTemplates());
      }

      Message.success(
        i18n('entities.appUser.destroyAll.success'),
      );

      getHistory().push('/app-user');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());
      dispatch(listActions.doFetchTemplates());

      dispatch({
        type: appUserDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default appUserDestroyActions;
